/* eslint-disable camelcase */
import { ref } from 'vue';

export const useSelection = () => {
    const selectedProducts = ref([]);

    const isSelected = (product) => {
        if (product?.variation_id) {
            return !!selectedProducts.value.find(
                (selectedProduct) =>
                    selectedProduct.id === product.id &&
                    selectedProduct?.variation_id === product?.variation_id,
            );
        }

        return !!selectedProducts.value.find(
            (selectedProduct) => selectedProduct.id === product.id,
        );
    };
    const addToSelected = (product) => {
        if (isSelected(product)) return;
        selectedProducts.value.push({
            id: product.id,
            ...(product.variation_id ? { variation_id: product.variation_id } : null),
        });
    };
    const removeFromSelected = (product) => {
        if (product.variation) {
            selectedProducts.value = selectedProducts.value.filter(
                (selectedProduct) =>
                    selectedProduct.id === product.id &&
                    selectedProduct.variation_id !== product.variation_id,
            );
        }

        selectedProducts.value = selectedProducts.value.filter(
            (selectedProduct) => selectedProduct.id !== product.id,
        );
    };

    const toggleSelected = (product) => {
        if (isSelected(product)) {
            removeFromSelected(product);
        } else {
            addToSelected(product);
        }
    };

    return { isSelected, addToSelected, removeFromSelected, selectedProducts, toggleSelected };
};
